'use client';
import { Layout } from '@sbercloud/uikit-product-site-layout';
import { usePathname } from 'next/navigation';

import { Condition } from '@/components/static';
import { STATIC_PAGES } from '@/constant/common';
import { STATIC_PAGES_PATH_NAMES } from '@/constant/routes';
import { useAppNavigationCtx } from '@/hooks/ctx';

import { LayoutSectionWrapper } from '../LayoutSectionWrapper';
import { GlobalNavigation } from './GlobalNavigation';
import { LogoWithDocs } from './LogoWithDoc';
import { HeaderRightSection } from './RightSection';
import { HeaderSERPInput } from './SERPInput';
import s from './styles.module.scss';

export function Header() {
  const pathname = usePathname();
  const { activeAppNavigationItemByRoute } = useAppNavigationCtx();
  const isStaticPage = Object.values(STATIC_PAGES_PATH_NAMES).includes(pathname);

  const isMainPage = Boolean(activeAppNavigationItemByRoute) || STATIC_PAGES.includes(pathname);
  return (
    <Layout.Header className={s.root}>
      <LayoutSectionWrapper className={!isMainPage ? s.articles_layout_section : undefined}>
        <div className={s.header_wrapper}>
          <div className={s.about}>
            <LogoWithDocs />
            <Condition when={!isStaticPage}>
              <div className={s.platform_select}>
                <GlobalNavigation containerClassName={s.platform_select_container} />
              </div>
            </Condition>
          </div>
          <div className={s.controls}>
            <HeaderSERPInput />
            <HeaderRightSection />
          </div>
        </div>
      </LayoutSectionWrapper>
    </Layout.Header>
  );
}
